<template>
  <div>
    <footer>
      <p>
        All Rights Reserved.
        <br>Powered by JD SPORTS FASHION PLC
      </p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Footers',
  data() {
    return {
      msg: 'Footer',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
footer {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  background-color: black;
  color: white;
  text-align: center;
  font-size: 0.7rem;
  z-index: 4;
}
</style>
